module.exports = __webpack_public_path__ + "img/user-select.dae7279a.png";